import React from "react";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import keycloak, { EFN_KEYCLOAK_SCOPE } from "./Keycloak"
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Homepage";



const keycloakProviderInitConfig = {
    onLoad: 'check-sso',
    scope: EFN_KEYCLOAK_SCOPE,
    silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
    checkLoginIframe: false, // Disable iframe polling to prevent issues
}

const onKeycloakEvent = (event, error) => {
    console.log('onKeycloakEvent', event, error)
}

const onKeycloakTokens = (tokens) => {
    console.log('onKeycloakTokens', tokens)
    const token = tokens?.token;
    if (token) {
        localStorage.setItem('token', token);
    } else {
        localStorage.removeItem('token');
    }
}

// Remove conflicting token refresh handler - we handle it in Apollo authLink instead



function App() {
    return (
        <div>
            <ReactKeycloakProvider
                authClient={keycloak}
                initConfig={keycloakProviderInitConfig}
                onEvent={onKeycloakEvent}
                onTokens={onKeycloakTokens}
            >
                <div>
                    <BrowserRouter>
                        <Routes>
                            <Route exact path="/" element={<Home/>}/>
                        </Routes>
                    </BrowserRouter>
                </div>
            </ReactKeycloakProvider>
        </div>
    );
}

export default App;
